var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFallbackimage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphic Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1261153376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_13496_50056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4834 0.884779C19.8629 -0.294926 22.1221 -0.294926 23.5216 0.884779L26.6804 3.6041C27.2801 4.12397 28.3997 4.54386 29.1994 4.54386H32.5982C34.7174 4.54386 36.4567 6.28343 36.4567 8.4029V11.802C36.4567 12.5819 36.8765 13.7216 37.3964 14.3214L40.1153 17.4806C41.2949 18.8603 41.2949 21.1197 40.1153 22.5194L37.3964 25.6786C36.8765 26.2784 36.4567 27.3982 36.4567 28.198V31.5971C36.4567 33.7166 34.7174 35.4561 32.5982 35.4561H29.1994C28.4197 35.4561 27.2801 35.876 26.6804 36.3959L23.5216 39.1152C22.1421 40.2949 19.8829 40.2949 18.4834 39.1152L15.3246 36.3959C14.7249 35.876 13.6053 35.4561 12.8056 35.4561H9.34687C7.22766 35.4561 5.48832 33.7166 5.48832 31.5971V28.178C5.48832 27.3982 5.06847 26.2784 4.56866 25.6786L1.86967 22.4994C0.710109 21.1197 0.710109 18.8803 1.86967 17.5006L4.56866 14.3214C5.06847 13.7216 5.48832 12.6018 5.48832 11.822V8.3829C5.48832 6.26343 7.22766 4.52387 9.34687 4.52387H12.8056C13.5853 4.52387 14.7249 4.10397 15.3246 3.5841L18.4834 0.884779Z",
    fill: "#1C2B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8083 1.2649L18.8084 1.26478C19.9988 0.246739 21.9826 0.243172 23.1974 1.26549C23.198 1.26602 23.1987 1.26655 23.1993 1.26707L26.3529 3.98192C26.3531 3.98213 26.3534 3.98234 26.3536 3.98254C26.7114 4.29247 27.1983 4.5536 27.6899 4.7373C28.1819 4.92113 28.7225 5.04386 29.1994 5.04386H32.5982C34.4412 5.04386 35.9567 6.55951 35.9567 8.4029V11.802C35.9567 12.2696 36.0798 12.8104 36.2629 13.3034C36.446 13.7961 36.7069 14.289 37.0179 14.6482C37.0181 14.6484 37.0183 14.6486 37.0185 14.6489L39.7353 17.8055C39.7356 17.8059 39.7359 17.8062 39.7361 17.8065C40.7532 18.9973 40.7565 20.9806 39.7346 22.1953C39.7341 22.1959 39.7335 22.1965 39.733 22.1972L37.0185 25.3511C37.0182 25.3514 37.018 25.3517 37.0177 25.352C36.7079 25.7098 36.4469 26.1967 36.2632 26.6883C36.0794 27.1803 35.9567 27.721 35.9567 28.198V31.5971C35.9567 33.4405 34.4412 34.9561 32.5982 34.9561H29.1994C28.7319 34.9561 28.1912 35.0792 27.6982 35.2624C27.2056 35.4455 26.7128 35.7064 26.3537 36.0174C26.3534 36.0176 26.3532 36.0178 26.3529 36.0181L23.1966 38.7352C23.1965 38.7353 23.1963 38.7355 23.1962 38.7356C22.0057 39.7533 20.0222 39.7567 18.8075 38.7345C18.8069 38.734 18.8063 38.7334 18.8057 38.7329L15.6521 36.0181C15.6519 36.0179 15.6517 36.0177 15.6515 36.0175C15.2937 35.7076 14.8067 35.4464 14.3151 35.2627C13.8231 35.0789 13.2825 34.9561 12.8056 34.9561H9.34687C7.50386 34.9561 5.98832 33.4405 5.98832 31.5971V28.178C5.98832 27.71 5.86511 27.1743 5.68483 26.6872C5.5043 26.1995 5.24958 25.7147 4.95279 25.3585L4.95281 25.3585L4.94983 25.355L2.25244 22.1777C2.25221 22.1774 2.25198 22.1771 2.25175 22.1769C1.24941 20.9834 1.24942 19.0166 2.25176 17.8231C2.25199 17.8229 2.25221 17.8226 2.25244 17.8223L4.94983 14.645L4.94984 14.645L4.95279 14.6415C5.24958 14.2853 5.5043 13.8005 5.68483 13.3128C5.86511 12.8257 5.98832 12.29 5.98832 11.822V8.3829C5.98832 6.53952 7.50387 5.02387 9.34687 5.02387H12.8056C13.2731 5.02387 13.8138 4.9008 14.3068 4.71762C14.7991 4.53465 15.2917 4.2739 15.6507 3.96315C15.6512 3.96274 15.6516 3.96233 15.6521 3.96193L18.8083 1.2649Z",
    stroke: "#FAFAFA",
    strokeOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9149 14.9641C17.9149 15.7724 17.2597 16.4276 16.4515 16.4276C15.6433 16.4276 14.9881 15.7724 14.9881 14.9641C14.9881 14.1559 15.6433 13.5007 16.4515 13.5007C17.2597 13.5007 17.9149 14.1559 17.9149 14.9641Z",
    fill: "#FAFAFA",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6723 14.9641C14.6723 13.9815 15.4689 13.1849 16.4515 13.1849C17.4341 13.1849 18.2307 13.9815 18.2307 14.9641C18.2307 15.9468 17.4341 16.7434 16.4515 16.7434C15.4689 16.7434 14.6723 15.9468 14.6723 14.9641Z",
    fill: "#FAFAFA",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6713 25.2083C27.6713 26.0165 27.0162 26.6717 26.208 26.6717C25.3998 26.6717 24.7446 26.0165 24.7446 25.2083C24.7446 24.4 25.3998 23.7449 26.208 23.7449C27.0162 23.7449 27.6713 24.4 27.6713 25.2083Z",
    fill: "#FAFAFA",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4288 25.2083C24.4288 24.2257 25.2253 23.4291 26.2079 23.4291C27.1906 23.4291 27.9871 24.2257 27.9871 25.2083C27.9871 26.1909 27.1906 26.9875 26.2079 26.9875C25.2253 26.9875 24.4288 26.1909 24.4288 25.2083Z",
    fill: "#FAFAFA",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.385 13.2982C27.766 13.6792 27.766 14.2969 27.385 14.6779L15.6779 26.3852C15.2969 26.7663 14.6792 26.7663 14.2982 26.3853C13.9172 26.0043 13.9172 25.3865 14.2982 25.0055L26.0053 13.2982C26.3863 12.9172 27.004 12.9172 27.385 13.2982Z",
    fill: "#FAFAFA",
    fillOpacity: 0.48
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13496_50056",
    x: 0,
    y: 0,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.168627 0 0 0 0 0.352941 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13496_50056"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13496_50056",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallbackimage);
export default __webpack_public_path__ + "static/media/Fallbackimage.5997468bc3071f87f62778a0d1838db7.svg";
export { ForwardRef as ReactComponent };